import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AuthState = {
  loading: boolean;
  error: string | null;
  toggleValue: number;
};

const initialState: AuthState = {
  loading: false,
  error: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signInStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    signInSuccess: (state) => {
      state.loading = false;
      state.error = null;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    signInFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    signOut: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
});

export const auth = slice.reducer;
export const { signInStart, signInSuccess, signInFailed, signOut } = slice.actions;
